import React from 'react';
import { formatCurrencyNoIcon } from '../../localisation/useCurrency';
import FormElement from '../FormElement';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import { FormInternationalPrice } from './FormIntPrice';

export function FormPricingField(props: ICommonFormProps) {
    function onChangeHandler(value: number) {
        if (props.setValue) {
            props.setValue(props.keyName, Math.round(value * 100), {
                shouldDirty: true,
            });
        }
    }
    const value = props.value ? formatCurrencyNoIcon(props.value) : undefined;
    return (
        <FormElement {...props}>
            <FormInternationalPrice {...props} defaultValue={value} onChange={onChangeHandler} />
        </FormElement>
    );
}
